import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/lib/components';
import { AwesomeFilterIcon, DeleteFilterIcon } from '@/lib/icon';
import { Flex } from '@/lib/v2/components/Layout/Stack';

import { filterDataArray } from '@/src/ContactsModule/utils/mockDataFilters';

type ItemsListProps = {
  id?: string;
  name: string;
  icon?: JSX.Element;
  value: FilterListProps[];
};

type FilterListProps = {
  id: number;
  title: string;
};

export const ContactsFiltersAdvanced = () => {
  const { t } = useTranslation();

  const array = new Array(20).fill(false);

  const [checkedState, setCheckedState] = useState(array);

  const cleanAllChecks = () => setCheckedState(array);

  const handleOnChange = (position: number) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
  };

  return (
    <>
      <Flex itemAlignment="start">
        {filterDataArray
          .map((category: ItemsListProps) => category)
          .map((item) => {
            return (
              <div key={item.name} className="px-2 align-top text-14">
                <div className="py-1 text-14 font-semibold text-[#005ADC]">
                  <Flex withGap alignment="start">
                    {item.icon}
                    {item.name}
                  </Flex>
                </div>
                {item.value.map((filter: FilterListProps, index) => {
                  return (
                    <Flex key={index} withGap alignment="start" gapSize="small">
                      <input
                        checked={checkedState[filter.id]}
                        className="rounded border-gray-300 bg-gray-100 text-blue-600"
                        id={`custom-checkbox-${filter.id}`}
                        type="checkbox"
                        onChange={() => handleOnChange(filter.id)}
                      />
                      <div>{filter.title}</div>
                    </Flex>
                  );
                })}
              </div>
            );
          })}
      </Flex>
      <div className="border[#E7F1FF] mt-5 border-t pt-5">
        <Flex withGap alignment="end" gapSize="small">
          <Button stroked Icon={<DeleteFilterIcon />} onAction={cleanAllChecks}>
            <div className="text-12 lg:text-12 xl:text-14 2xl:text-16">
              {t('CONTACTS_FILTERS.clean')}
            </div>
          </Button>
          <Button
            stroked
            Icon={<AwesomeFilterIcon />}
            onAction={() => {
              alert('Filter Apply');
            }}
          >
            <div className="text-12 lg:text-12 xl:text-14 2xl:text-16">
              {t('CONTACTS_FILTERS.applyFilter')}
            </div>
          </Button>
        </Flex>
      </div>
    </>
  );
};
